export class EventLoppService {
  static nextTick = (callback: () => void, time: number = 0) => {
    setTimeout(() => {
      callback();
    }, time);
  };
}
